import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ResultsInterpretation from "./pages/ResultsInterpretation";
import SubscriptionMonthly from "./pages/SubscriptionMonthly";
import SubscriptionAnnual from "./pages/SubscriptionAnnual";
import GuidePage from "./pages/GuidePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/how-it-works" element={<GuidePage />} />
        <Route path="/results" element={<ResultsInterpretation />} />
        <Route path="/pricing-monthly" element={<SubscriptionMonthly />} />
        <Route path="/pricing-annual" element={<SubscriptionAnnual />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;